<template>
  <Component
    :is="fieldset ? 'fieldset' : 'div'"
    class="s-base-input"
    :class="{ 's-input--invalid': displayInvalid }"
  >
    <SLabelAtom
      v-if="label || tooltip"
      v-bind="{ ...labelAtom.props, ...tooltipAtom.props }"
    />

    <SDescription v-if="description" v-bind="descriptionAtom.props" />

    <slot v-bind="inputSlot" name="input" />

    <SSubtext v-if="subtext" v-bind="subtextAtom.props" />

    <slot v-if="error" v-bind="errorProps" :id="errorId" :name="errorComponent">
      <SErrorAtom v-bind="errorProps" :id="errorId" />
    </slot>
  </Component>
</template>

<script setup lang="ts" generic="ModelValue">
import type {
  UseBaseInputEmit,
  UseBaseInputProps,
} from "@/lib/components/logic/molecules/useBaseInput.ts";

import SSubtext from "@/lib/components/atoms/subtext/SSubtext.vue";
import * as useBaseInput from "@/lib/components/logic/molecules/useBaseInput.ts";

import SDescription from "../atoms/alert/SDescription.vue";
import SErrorAtom from "../atoms/error/SErrorAtom.vue";
import SLabelAtom from "../atoms/label/SLabelAtom.vue";

const props = defineProps<UseBaseInputProps<ModelValue>>();

const emit = defineEmits<UseBaseInputEmit>();

const {
  labelAtom,
  tooltipAtom,
  descriptionAtom,
  subtextAtom,
  inputSlot,
  displayInvalid,
  errorId,
  error,
  errorComponent,
  errorProps,
} = useBaseInput.use(props, emit);
</script>

<style lang="postcss">
.s-base-input {
  @apply flex flex-col;

  &__label-container {
    @apply flex;
  }

  &__tooltip {
    @apply ml-2;
  }
}
</style>
